import { useParams } from "react-router-dom";
import { ICredential } from "../types/credential";
import { useAppSelector } from "./storeHooks";
import { selectCredByRef } from "../reducers/credentialsSlice";
import { useContext } from "react";
import UserContext from "../../../contexts/UserContext";
import { selectSelectedUserId } from "../reducers/credentialAppSlice";

interface IUseGetCredentialJoidParams {
  credential?: ICredential | undefined;
}

const useGetCredentialJoid = ({ credential: credentialParams }: IUseGetCredentialJoidParams) => {
  const userModel = useContext(UserContext);

  const { credentialId } = useParams();
  const credential = useAppSelector((state) =>
    selectCredByRef(state, credentialId)
  );
  const selectedUserId = useAppSelector(selectSelectedUserId);


  return credentialParams?.uid ?? credential?.uid ?? selectedUserId ?? userModel.getUser().uid;
};

export default useGetCredentialJoid;
